module.exports = __webpack_public_path__ + "static/media/logos_50h_huawei.c1f1774f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_huawei.jpg
// module id = 218
// module chunks = 0